import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';

@Component({
  selector: 'app-compprofile-tab',
  templateUrl: './compprofile-tab.component.html',
  styleUrls: ['./compprofile-tab.component.scss']
})
export class CompprofileTabComponent implements OnInit {

  constructor(private personSearchService: PersonSearchService, private location: Location, private companyinsightsService: CompanyInsightsService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService){ }
  companyDetails: any;
  currentCompanyName: any;
  totalFunctionResultCount: number = 0;
  functionsData: any = [];
  seniorityData: any = [];
  keyPeopleData: any = [];
  keyPeoplePDLIds: any = [];
  selectedMonth: any = '3';
  recentHiresDataAll: any[] = [];
  recentHiresData: any = [];
  totalRecentHiresCount: number = 0;
  showLoaderForKeyPeople: boolean = false;
  allKeyPeopleData: any = [];
  alternatecompanyNames: any[] = [];
  profilesubscription: Subscription;
  departmentemptystate: Boolean = false;
  seniorityemptystate: Boolean = false;
  keyemptystate: Boolean = false;
  recentemptystate: Boolean = false;

  /** start index in function page */
  recentHireStartIndex: number = 0;
  /**Number of items on each of function page */
  recentHirePageSize:number = 6;
  /**Current page number in function */
  recentHireCurrentPage: number = 1;
  /**Total items in function page*/
  recentHireTotalCount = 0;
  recentHireAggCount = 50;

  /** start index in function page */
  keyPeopleStartIndex: number = 0;
  /**End index in function page */
  keyPeopleEndIndex: number = 6;
  /**Number of items on each of function page */
  keyPeoplePageSize:number = 6;
  /**Current page number in function */
  keyPeopleCurrentPage: number = 1;
  /**Total items in function page*/
  keyPeopleTotalCount = 0;
  keyPeopleAggCount = 30;
  /** Subscription var */
  subscriptions: Array<Subscription> = [];
  departmentsdata: any = [];
  profiledataAI: any;
  seniorityaiData: any = [];
  insightsExportSubscription: Subscription = null;

  ngOnInit(): void {
    // this.profilesubscription = this.personSearchService.companyDetail.subscribe((response) => {
    //   this.companyDetails = response;
    //   this.recentHiresData = []
    //   this.allKeyPeopleData = []
    //   this.currentCompanyName = this.companyDetails.name;
    //   this.alternatecompanyNames =  this.companyDetails.alternative_names &&  this.companyDetails.alternative_names.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]): [this.currentCompanyName];

    //   this.recentHireCurrentPage = 1;
    //   this.recentHireStartIndex = 0;
    //   this.recentHireAggCount = 50;

    //   this.keyPeopleCurrentPage = 1;
    //   this.keyPeopleStartIndex = 0;
    //   this.keyPeopleEndIndex = 6;
      
    //   this.showLoaderForKeyPeople = true;
    //   this.getFunction();
    //   this.getSeniority();
    //   this.keyPeoplePDLIds = this.companyDetails?.recent_exec_hires?.length && this.companyDetails?.recent_exec_hires.map(x => x.pdl_id);
    //   this.getKeyPeopleData();
    //   this.getRecentHires();
    // });

    this.setCompanyDetails();
    this.fetchPageData();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.fetchPageData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightsService.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightsService.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
    this.keyPeoplePDLIds = this.companyDetails?.recent_exec_hires?.length && this.companyDetails?.recent_exec_hires.map(x => x.pdl_id);

  }

  fetchPageData() {
     this.getFunction();
      this.getSeniority();
      this.getKeyPeopleData();
      this.getRecentHires();
      this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);
  }

  getFunction() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "function";
    aggReq.aggregatescount = 50;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.totalFunctionResultCount = response.data.totalresultscount;
      this.functionsData = response.data.aggregations.function.slice(0, 5);
      this.getprofileai(response.data.aggregations.function, 'departments')
      this.departmentemptystate = true;
      const CharForFunction = [];

      const count = this.functionsData.map(x => x.doc_count).reduce((a, b) => a + b, 0);
      const othersCount = count - this.totalFunctionResultCount;
      if (othersCount) {
        this.functionsData.push({
          key: "Others",
          doc_count: othersCount,
        })
      }

      this.functionsData && this.functionsData.forEach(x => {
        let dataObj = {
          label: this.convertToTitleCase(this.cleanCompanyName(x.key)),
          value: x.doc_count,
          tooltext: `$label <br> Talent Count: $dataValue`
        }
        CharForFunction.push(dataObj)
      })


      this.functionsData = {
        "type": "doughnut2d",
        "dataFormat": "json",
        "width": "50%",
        "chart": {
          "paletteColors": "#eacc39, #8585dd, #e23b80, #aaaaaa, #95e1d3, #1B4E6B, #3934a5",
          "use3DLighting": "0",
          "decimals": "0",
          "yAxisNameFontColor": '#2C2C2C',
          "animateClockwise": "1",
          "legendPosition": "bottom",
          "enableSmartLabels":"1",
          "manageLabelOverflow":"1",
          "useEllipsesWhenOverflow":"1",
          // "legendNumColumns": "4",
          "legendAllowDrag": "0",
          "theme": "fusion",
          "legendWidth": "500",
          "formatNumberScale": "0",
          "thousandSeparatorPosition": "2,3",
          "labelFont": "Poppins",
          "legendItemFont": "Poppins"
        },
        "data": CharForFunction
      }
    });
  }

  getSeniority() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "seniority";
    aggReq.aggregatescount = 50;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.seniorityData = response.data.aggregations.seniority.slice(0, 5);
      this.getprofileai(response.data.aggregations.seniority, 'seniority')
      this.seniorityemptystate = true;
      const CharForSeniority = [];

      this.seniorityData && this.seniorityData.forEach(x => {
        let dataObj = {
          label: this.convertToTitleCase(this.cleanCompanyName(x?.key)),
          value: x.doc_count,
          tooltext: `$label <br> Talent Count: $dataValue`
        }
        CharForSeniority.push(dataObj)
      })


      this.seniorityData = {
        "type": "doughnut2d",
        "dataFormat": "json",
        "chart": {
          "paletteColors": "#eacc39, #86db94, #8585dd, #aaaaaa, #95e1d3, #1B4E6B, #3934a5, #1B4E6B",
          "use3DLighting": "0",
          "decimals": "0",
          "yAxisNameFontColor": '#2C2C2C',
          "animateClockwise": "1",
          "legendPosition": "bottom",
          "legendAllowDrag": "0",
          "enableSmartLabels":"1",
          "manageLabelOverflow":"1",
          "useEllipsesWhenOverflow":"1",
          "theme": "fusion",
          "legendWidth": "500",
          "formatNumberScale": "0",
          "thousandSeparatorPosition": "2,3",
          "labelFont": "Poppins",
          "legendItemFont": "Poppins"
        },
        "data": CharForSeniority
      }
    });
  }

  private cleanCompanyName(companyName: string): string {
    return companyName?.replace(/_/g, ' ');
  }

  getKeyPeopleData() {
    if(this.keyPeoplePDLIds?.length) {
      this.showLoaderForKeyPeople = true;
      this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
      const requestObject = this.aggService.getRequestWithFilters();
      requestObject.ids = this.keyPeoplePDLIds;
      this.personSearchService.getKeyPeople(requestObject).subscribe((response) => {
        if(response && response.data){
          const tempData = response.data;
          this.allKeyPeopleData = tempData;
          this.keyPeopleTotalCount = tempData.length;
          this.keyPeopleData = tempData.slice(this.keyPeopleStartIndex, this.keyPeopleEndIndex);
          this.showLoaderForKeyPeople = false;
          this.keyemptystate = true;
        }
      });
    }

  }

  filterselected(event) {
    this.selectedMonth = event.target.value;
    this.recentHireStartIndex = 0;
    this.recentHireAggCount = 50;
    this.recentHireCurrentPage = 1;
    this.recentHiresData = [];
    this.getRecentHires();
  }

  convertToTitleCase(stringName){
    stringName = stringName?.toLowerCase()?.split(' ');
    for(let i = 0;i<stringName?.length;i++){
      stringName[i] = stringName[i].charAt(0).toUpperCase() + stringName[i].slice(1);
    }
    return stringName?.join(' ');
  }

  getRecentHires() {
    // const requestObject = {
    //   companies: this.alternatecompanyNames,
    //   durationinmonths: parseInt(this.selectedMonth),
    //   resultsize: this.recentHireAggCount,
    //   startindex: this.recentHireStartIndex,
    //   preferredskills: this.companyDetails && this.companyDetails['skills'] ? this.companyDetails['skills']:[],
    //   locations: this.companyDetails && this.companyDetails['locations'] ? this.companyDetails['locations']:[],
    //   functions: this.companyDetails && this.companyDetails['functions'] ? this.companyDetails['functions']:[]
    // }
    this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const requestObject = this.aggService.getRequestWithFilters();
    requestObject.companies = this.alternatecompanyNames;
    requestObject.durationinmonths = parseInt(this.selectedMonth);
    requestObject.resultsize = this.recentHireAggCount;
    requestObject.startindex = this.recentHireStartIndex;
    this.personSearchService.getRecentHires(requestObject).subscribe((response) => {
      if(response && response.data){
        this.recentHiresDataAll = response.data;
        this.recentHiresData = this.recentHiresDataAll.splice(0, 6);
        this.totalRecentHiresCount = response.totalresultscount || 0;
        this.recentemptystate = true;
      }
    });
  }

  /**
   * Function set the start and end of recent hire data according to page number
   * @param index page number in pagination
   */
  setPageRecentHire(index: number){
    this.recentHireStartIndex = (index - 1) * this.recentHirePageSize;
    this.recentHireCurrentPage = index;
    this.getRecentHires();
  }

  /**
   * Function set the start and end of key pepole data according to page number
   * @param index page number in pagination
   */
  setPageKeyPeople(index: number){
    this.keyPeopleStartIndex = (index - 1) * this.keyPeoplePageSize;
    this.keyPeopleEndIndex = this.keyPeopleStartIndex + this.keyPeoplePageSize;
    this.keyPeopleCurrentPage = index;
    if(this.keyPeopleAggCount / this.recentHirePageSize <= index) this.keyPeoplePageSize = this.keyPeopleAggCount + this.keyPeoplePageSize;
    this.getKeyPeopleData();
  }

  /**
   * destroy subscriptions of filters
   */
   ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if(requestData?.data?.currentTab !== 'profile') return;

    // functions chart config
    const functionChart = { renderAt: 'functionsChart', dataSource: { ...this.functionsData } };
    functionChart['type'] = functionChart['dataSource']['type'];
    delete functionChart?.['dataSource']?.['type'];
    delete functionChart?.['dataSource']?.['width'];
    delete functionChart?.['dataSource']?.['chart']?.['width'];
    delete functionChart?.['dataSource']?.['height'];
    delete functionChart?.['dataSource']?.['chart']?.['height'];
    delete functionChart?.['dataSource']?.['chart']?.['renderAt'];

    // seniority chart config
    const seniorityChart = { renderAt: 'seniorityChart', dataSource: { ...this.seniorityData } };
    seniorityChart['type'] = seniorityChart['dataSource']['type'];
    delete seniorityChart?.['dataSource']?.['type'];
    delete seniorityChart?.['dataSource']?.['width'];
    delete seniorityChart?.['dataSource']?.['chart']?.['width'];
    delete seniorityChart?.['dataSource']?.['height'];
    delete seniorityChart?.['dataSource']?.['chart']?.['height'];
    delete seniorityChart?.['dataSource']?.['chart']?.['renderAt'];

    const payloadForInsightsExport: ExportPayload = {
      tab: 'profile',
      companydetails: this.companyDetails,
      totalresultcount: this.totalFunctionResultCount,
      chartdetails: [].concat(this.functionsData?.data?.length ? functionChart : []).concat(this.seniorityData?.data?.length ? seniorityChart : []),
      recentHires: this.recentHiresDataAll,
      selectedMonth: this.selectedMonth,
      totalRecentHiresCount: this.totalRecentHiresCount
    }
    this.companyinsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  getprofileai(data, type) {
    if(type == 'departments') {
     this.departmentsdata = data.map(x=>{
        let res: any ={};
        res['Department'] = x.key;
        res['Talent Count'] = x.doc_count;
       
        return res;
      })
    } if(type == 'seniority') {
      this.seniorityaiData = data.map(x=>{
        let res:any = {};
        res['Seniority'] = x.key;
        res['Talent Count'] = x.doc_count;
        return res;
      })
    } 
    
    this.profiledataAI = {
      departments: this.departmentsdata,
      seniority: this.seniorityaiData
    } 
    if(this.departmentsdata?.length == 0 && this.seniorityaiData?.length == 0)
      this.profiledataAI = null;
  }
}
